"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataItem_1 = require("../common/base/DataItem");
var Field_1 = require("../../constants/Field");
var SubCondition = /** @class */ (function () {
    function SubCondition() {
    }
    SubCondition.fromJson = function (name, json) {
        var subCondition = new SubCondition();
        subCondition.name = name;
        if (json[Field_1.FIELD.DESCRIPTION] !== undefined) {
            subCondition.description = DataItem_1.DataItem.fromJson(Field_1.FIELD.DESCRIPTION, json[Field_1.FIELD.DESCRIPTION]);
        }
        if (json[Field_1.FIELD.POSSIBLECAUSE]) {
            subCondition.possibleCause = DataItem_1.DataItem.fromJson(Field_1.FIELD.POSSIBLECAUSE, json[Field_1.FIELD.POSSIBLECAUSE]);
        }
        if (json[Field_1.FIELD.SUGGESTEDACTION] !== undefined) {
            subCondition.suggestedAction = DataItem_1.DataItem.fromJson(Field_1.FIELD.SUGGESTEDACTION, json[Field_1.FIELD.SUGGESTEDACTION]);
        }
        if (json[Field_1.FIELD.CORRECTIVEACTION] !== undefined) {
            subCondition.correctiveAction = DataItem_1.DataItem.fromJson(Field_1.FIELD.CORRECTIVEACTION, json[Field_1.FIELD.CORRECTIVEACTION]);
        }
        if (json[Field_1.FIELD.LOGIC] !== undefined) {
            subCondition.logic = DataItem_1.DataItem.fromJson(Field_1.FIELD.LOGIC, json[Field_1.FIELD.LOGIC]);
        }
        if (json[Field_1.FIELD.SEVERITY] !== undefined) {
            subCondition.severity = DataItem_1.DataItem.fromJson(Field_1.FIELD.SEVERITY, json[Field_1.FIELD.SEVERITY]);
        }
        if (json[Field_1.FIELD.STATUS] !== undefined) {
            subCondition.status = DataItem_1.DataItem.fromJson(Field_1.FIELD.STATUS, json[Field_1.FIELD.STATUS]);
        }
        return subCondition;
    };
    SubCondition.prototype.toJson = function (includeOnlyValueOrLink) {
        var _a, _b, _c, _d, _e, _f, _g;
        var json = Object.create(null);
        var _h = this.getSubconditionsFields(includeOnlyValueOrLink), severityJson = _h[0], descriptionJson = _h[1], causeJson = _h[2], suggestedActionJson = _h[3], correctiveActionJson = _h[4], logicJson = _h[5], statusJson = _h[6];
        var name = this.name;
        if (severityJson) {
            json[name] = Object.assign({}, json[name], (_a = {},
                _a[Field_1.FIELD.SEVERITY] = severityJson,
                _a));
        }
        if (descriptionJson) {
            json[name] = Object.assign({}, json[name], (_b = {},
                _b[Field_1.FIELD.DESCRIPTION] = descriptionJson,
                _b));
        }
        if (causeJson) {
            json[name] = Object.assign({}, json[name], (_c = {},
                _c[Field_1.FIELD.POSSIBLECAUSE] = causeJson,
                _c));
        }
        if (suggestedActionJson) {
            json[name] = Object.assign({}, json[name], (_d = {},
                _d[Field_1.FIELD.SUGGESTEDACTION] = suggestedActionJson,
                _d));
        }
        if (correctiveActionJson) {
            json[name] = Object.assign({}, json[name], (_e = {},
                _e[Field_1.FIELD.CORRECTIVEACTION] = correctiveActionJson,
                _e));
        }
        if (logicJson) {
            json[name] = Object.assign({}, json[name], (_f = {}, _f[Field_1.FIELD.LOGIC] = logicJson, _f));
        }
        if (statusJson) {
            json[name] = Object.assign({}, json[name], (_g = {},
                _g[Field_1.FIELD.STATUS] = statusJson,
                _g));
        }
        return json;
    };
    SubCondition.prototype.getSubconditionsFields = function (includeOnlyValueOrLink) {
        var severityJson = this.severity !== undefined
            ? this.severity.isDirty === true || this.severity.isDirty === undefined
                ? this.severity.toJson(includeOnlyValueOrLink)
                : undefined
            : undefined;
        var descriptionJson = this.description !== undefined
            ? this.description.isDirty === true ||
                this.description.isDirty === undefined
                ? this.description.toJson(includeOnlyValueOrLink)
                : undefined
            : undefined;
        var causeJson = this.possibleCause !== undefined
            ? this.possibleCause.isDirty === true ||
                this.possibleCause.isDirty === undefined
                ? this.possibleCause.toJson(includeOnlyValueOrLink)
                : undefined
            : undefined;
        var suggestedActionJson = this.suggestedAction !== undefined
            ? (this.suggestedAction.isDirty === true ||
                this.suggestedAction.isDirty === undefined) === true
                ? this.suggestedAction.toJson(includeOnlyValueOrLink)
                : undefined
            : undefined;
        var correctiveActionJson = this.correctiveAction !== undefined
            ? this.correctiveAction.isDirty === true ||
                this.correctiveAction.isDirty === undefined
                ? this.correctiveAction.toJson(includeOnlyValueOrLink)
                : undefined
            : undefined;
        var logicJson = this.logic !== undefined
            ? this.logic.isDirty === true || this.logic.isDirty === undefined
                ? this.logic.toJson(includeOnlyValueOrLink)
                : undefined
            : undefined;
        var statusJson = this.status !== undefined
            ? this.status.isDirty === true || this.status.isDirty === undefined
                ? this.status.toJson(includeOnlyValueOrLink)
                : undefined
            : undefined;
        if (severityJson && !severityJson[Field_1.FIELD.VALUE]) {
            severityJson[Field_1.FIELD.VALUE] = 0;
        }
        if (descriptionJson && !descriptionJson[Field_1.FIELD.VALUE]) {
            descriptionJson[Field_1.FIELD.VALUE] = "";
        }
        if (causeJson && !causeJson[Field_1.FIELD.VALUE]) {
            causeJson[Field_1.FIELD.VALUE] = "";
        }
        if (suggestedActionJson && !suggestedActionJson[Field_1.FIELD.VALUE]) {
            suggestedActionJson[Field_1.FIELD.VALUE] = "";
        }
        if (correctiveActionJson && !correctiveActionJson[Field_1.FIELD.VALUE]) {
            correctiveActionJson[Field_1.FIELD.VALUE] = "";
        }
        if (logicJson && !logicJson[Field_1.FIELD.VALUE]) {
            logicJson[Field_1.FIELD.VALUE] = "";
        }
        if (statusJson && !statusJson[Field_1.FIELD.VALUE]) {
            statusJson[Field_1.FIELD.VALUE] = "";
        }
        return [
            severityJson,
            descriptionJson,
            causeJson,
            suggestedActionJson,
            correctiveActionJson,
            logicJson,
            statusJson,
        ];
    };
    return SubCondition;
}());
exports.SubCondition = SubCondition;
//# sourceMappingURL=SubCondition.js.map